import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useInfluencer } from '@client/new/hooks/use-influencer';
import { useProfileVM } from '../view-model/Profile.viewModel';
import { ProfileView } from './Profile.view';

type RouteParams = {
  influencerId?: string;
};

export const ProfilePage = (props: { params: RouteParams }) => {
  const { influencer } = useInfluencer();
  const creatorId = Number(props.params.influencerId || influencer?.id);

  const vm = useProfileVM(creatorId);

  return (
    <AsyncRenderer data={vm} renderer={(data) => <ProfileView {...data} />} />
  );
};
